"use client";

import { useState } from "react";
import { useSearchParams } from "next/navigation";
import { signIn } from "next-auth/react";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/field";

/**
 * Deux modes d'entrée (décision A4). Google est proposé en premier parce que
 * c'est le chemin sans mot de passe à retenir ; l'identifiant classique reste
 * disponible pour les personnes sans compte Google.
 */
export function LoginForm() {
  const params = useSearchParams();
  const suite = params.get("suite") ?? "/";
  const [mode, setMode] = useState<"google" | "motdepasse">("google");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(messageFor(params.get("erreur")));

  async function submitPassword(e: React.FormEvent) {
    e.preventDefault();
    setPending(true);
    setError(null);
    const res = await signIn("credentials", { email, password, redirect: false });
    setPending(false);
    if (res?.error) {
      setError("Adresse ou mot de passe incorrect.");
      return;
    }
    window.location.href = suite;
  }

  return (
    <div className="rounded-[12px] border border-line bg-surface p-6">
      {error ? (
        <div className="mb-4 rounded-[8px] border border-crit bg-crit/8 px-3 py-2 text-[13px] text-crit">
          {error}
        </div>
      ) : null}

      {mode === "google" ? (
        <div className="space-y-3">
          <Button
            className="w-full justify-center"
            onClick={() => signIn("google", { redirectTo: suite })}
          >
            Continuer avec Google
          </Button>
          <Button
            variant="secondary"
            className="w-full justify-center"
            onClick={() => setMode("motdepasse")}
          >
            Utiliser une adresse et un mot de passe
          </Button>
        </div>
      ) : (
        <form onSubmit={submitPassword} className="space-y-4">
          <Field label="Adresse e-mail">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>
          <Field label="Mot de passe">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          <Button type="submit" className="w-full justify-center" disabled={pending}>
            {pending ? "Connexion…" : "Se connecter"}
          </Button>
          <Button
            type="button"
            variant="ghost"
            className="w-full justify-center"
            onClick={() => setMode("google")}
          >
            Revenir à Google
          </Button>
        </form>
      )}
    </div>
  );
}

function messageFor(code: string | null): string | null {
  if (!code) return null;
  if (code === "non-invite") {
    return "Ce compte n'a pas encore été invité. Demande une invitation à l'administration.";
  }
  return "La connexion a échoué. Réessaie.";
}
